module.exports = __webpack_public_path__ + "static/media/logout.504cdcb9.svg";